import * as Sentry from "@sentry/react";
import { toast } from "sonner";

export const AUTO_TAG_START_FAILURE_MESSAGE =
  "오토태깅에 실패했습니다. 재시도해주세요.";

/**
 * 오토태깅 시작 실패를 사용자에게 알린다.
 *
 * 사용자에게는 원인과 무관하게 같은 문구로 뭉갠다 — 락 경합(423)이든 네트워크
 * 오류든 취할 행동이 같기 때문이다. 대신 원인이 어디에도 안 남으면 추적이 끊기므로
 * Sentry 로 보고한다. 특히 `mutationFn` 의 id 가드는 계약 위반이라 재시도로 풀리지
 * 않는데, 이 보고가 없으면 그 경로가 밟히는지조차 알 수 없다.
 */
export const notifyAutoTagStartFailure = (error: unknown) => {
  Sentry.captureException(error, { tags: { feature: "auto-tag" } });
  toast.error(AUTO_TAG_START_FAILURE_MESSAGE);
};
